export default __webpack_public_path__ + "static/media/frutiger-65bold.3151eef2.svg";